import { render } from "./LayoutSlot.vue?vue&type=template&id=4f8c32a5&scoped=true"
import script from "./LayoutSlot.vue?vue&type=script&lang=js"
export * from "./LayoutSlot.vue?vue&type=script&lang=js"

import "./LayoutSlot.vue?vue&type=style&index=0&id=4f8c32a5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8c32a5"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QImg});
